// Structural shape needed from `Price` (see `~/interfaces/subscriptions`) for this helper.
type CheckoutPrice = {
  interval?: string;
  amount_cents?: number;
  premium_offer?: {
    offer_type?: string;
    paid_trial_price_cents?: number | null;
  } | null;
};

// The amount charged today: $0 for a free trial, the paid-trial price when the price carries a
// paid-trial offer. Single source for the Payment Request / Apple Pay / Link total, so wallet
// payments don't display (and authorize) the full price instead of what's actually due today.
const getCheckoutAmountCents = (price: CheckoutPrice | undefined, donationAmountCents: number): number => {
  if (price?.interval === 'donation') return donationAmountCents;
  if (price?.premium_offer?.offer_type === 'trial_period') return 0;
  if (price?.premium_offer?.offer_type === 'paid_trial' && price.premium_offer.paid_trial_price_cents != null) {
    return price.premium_offer.paid_trial_price_cents;
  }
  return price?.amount_cents || 0;
};

export default getCheckoutAmountCents;
